import { Link } from 'react-router';
import { cn } from '@rocco/utils/cn';
import { BLEED_GUTTER_X } from '~/ui-rocco/pages/detail-shared';
import type { RevampCategoryChip } from '../type';

interface TrendingCategoriesProps {
    categories: RevampCategoryChip[];
    className?: string;
}

/**
 * The discovery block on /articles: a label above a wrapping grid of outlined
 * category chips.
 *
 * Deliberately not the category pages' pill rail. The landing page promotes a
 * set of categories to browse into, so it wraps and shows them all; the
 * category pages navigate a level of the tree, so they scroll.
 *
 * Geometry is Figma 60:2032 at 1920: 47px margins, 41px chips on an 8.04px
 * gap, outlined rather than filled.
 */
export const TrendingCategories = ({
    categories,
    className,
}: TrendingCategoriesProps) => {
    if (categories.length === 0) return null;

    return (
        <section
            aria-labelledby="trending-categories-label"
            className={cn('px-[1.5rem]', BLEED_GUTTER_X, className)}
        >
            <p
                id="trending-categories-label"
                className="m-0 flex h-[2.3481rem] items-start font-sans text-[0.9375rem] leading-[1.22] font-medium tracking-[-0.0469rem] text-[#9a9a9a]"
            >
                Trending Categories
            </p>

            <div className="flex flex-wrap gap-[0.5026rem]">
                {categories.map((category) => (
                    <Link
                        key={category.id}
                        to={category.link}
                        prefetch="intent"
                        className="flex h-[2.5625rem] items-center justify-center rounded-full border-[1.34px] border-solid border-black px-[1.1726rem] font-sans text-[1.0051rem] leading-[2.5128rem] font-normal whitespace-nowrap text-[#1f1f21] uppercase transition-colors hover:bg-black hover:text-white"
                    >
                        {category.title}
                    </Link>
                ))}
            </div>
        </section>
    );
};
